import { useMemo } from "react";
import { usePubContext } from "../../hooks/pub-context";
import {
  PremiumPubInfoFacilitiesWrapper,
  PremiumPubInfoWrapper,
} from "./style";
import { getFacilityContent } from "../../../../../utils/constants";
import PremiumPubInfoContents from "./components/contents";
import PremiumPubInfoReport from "./components/report";
import PremiumPubInfoSkeleton from "./skeleton";

const PremiumPubInfo = () => {
  const { data, loading } = usePubContext();

  const facilities = useMemo(() => {
    const list = data?.facilities.map((item) => getFacilityContent(item));
    return list?.filter((item) => item !== null);
  }, [data]);

  if (loading || !data) return <PremiumPubInfoSkeleton />;

  return (
    <PremiumPubInfoWrapper>
      <PremiumPubInfoContents />
      <PremiumPubInfoFacilitiesWrapper>
        {facilities?.map((item, index) => (
          <div className="item" key={index}>
            <img
              alt="item"
              src={`/image-web/store/Detail/Property%201=${item?.img}.svg`}
            />
            <span>{item?.title}</span>
          </div>
        ))}
      </PremiumPubInfoFacilitiesWrapper>
      <PremiumPubInfoReport />
    </PremiumPubInfoWrapper>
  );
};

export default PremiumPubInfo;
